import { makeStyles, Typography } from "@material-ui/core"
import { useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import React from "react"

const useStyles = makeStyles((theme) => ({
  title: {
    color: '#FBBE66',
    marginTop: theme.spacing(1),
    ["@media (min-width:960px)"]: {
      marginTop: theme.spacing(6),
    },
  },
  header: {
    color: "#fff",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontSize: '2.5rem',
    fontWeight: 'bold',
    ["@media (min-width:960px)"]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },

}))

export default function PageTitle({ title = "Title", header = "Header" }) {
  const classes = useStyles()
  const theme = useTheme()
  const isMD = useMediaQuery(theme.breakpoints.up("md"))

  return (
    <>
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>
       <Typography className={classes.header}>
        {header}
      </Typography>



       {/* <Typography style={{
         fontSize: '1.0rem'
       }} className={classes.title}>
        {title}
      </Typography>
       <Typography style={{
         fontSize: '2.4rem'
       }} className={classes.header}>
        {header}
      </Typography> */}
    </>
  )
}
